import { useEffect } from 'react';

import Container from '@mui/material/Container';

import { notification } from '@webclient/components/notification';
import CONFIG from '@webclient/components/workspace/setup/config';
import StyledModal from '@webclient/components/workspace/setup/sections/modal-stepper/styles';

import useGetCredit from '@webclient/hooks/useGetCredit';
import useQueryParams from '@webclient/hooks/useQueryParams';

import { useTranslate } from '@tolgee/react';

export default function ModalWrapper({ children }: React.PropsWithChildren) {
  const { getQueryParamByKey } = useQueryParams();
  const actionQueryParam = getQueryParamByKey<'setup-workspace' | null>(
    'action',
  );
  const { getAccountType } = useGetCredit();
  const accountType = getAccountType();
  const { t } = useTranslate();
  const canNotCreateWorkspace =
    accountType === 'free' || accountType === 'visitor';

  useEffect(() => {
    if (canNotCreateWorkspace && actionQueryParam === 'setup-workspace') {
      notification.info({
        message: t(
          'page.workspace.createButton.cta.visitor',
          'Upgrade now to create more Knowledge Bases',
        ),
      });
    }
  }, [canNotCreateWorkspace, accountType, t, actionQueryParam]);

  if (canNotCreateWorkspace) {
    return null;
  }

  return (
    <StyledModal
      open={actionQueryParam === 'setup-workspace'}
      width={{
        xs: CONFIG.MODAL.MOBILE.WIDTH,
        md: CONFIG.MODAL.DESKTOP.WIDTH,
      }}
      height={{
        xs: CONFIG.MODAL.MOBILE.HEIGHT,
        md: CONFIG.MODAL.DESKTOP.HEIGHT,
      }}
    >
      <Container disableGutters>{children}</Container>
    </StyledModal>
  );
}
